export const VEHICLE_COUNT = 10;
export const STATIONS = ["stationA", "stationB"] as const;
export const CHARGERS_PER_STATION = 2;

export const MINUTES_PER_STEP = 5;
export const STEPS_PER_DAY = (24 * 60) / MINUTES_PER_STEP;

export const CHARGER_POWER_KW = 50;
export const CHARGE_PER_STEP_KWH = (CHARGER_POWER_KW * MINUTES_PER_STEP) / 60;

export const CHARGE_TRIGGER_SOC_RATIO = 0.7;
export const CHARGE_STOP_SOC_RATIO = 0.9;

export const BASE_TICK_MS = 160;

export const SPEED_OPTIONS = [
  { label: "1x", value: 1 },
  { label: "2x", value: 2 },
  { label: "5x", value: 5 },
] as const;

export const LA_MAP_CENTER: [number, number] = [34.0522, -118.2437];

export const STATION_COORDS = {
  stationA: [34.0358, -118.2465] as [number, number],
  stationB: [34.0698, -118.2076] as [number, number],
};
